<template>
  <div class="home-page">
    <el-card shadow="never" class="welcome-card">
      <div class="welcome">
        <h2>🐔 欢迎使用种鸡育种管理系统</h2>
        <p>菜单按模块划分，列表与报表数据均来自后端接口，除登录外统一携带 token 鉴权</p>
      </div>
    </el-card>

    <el-row :gutter="16">
      <!-- 响应式布局:手机 1 列、平板 2 列、笔记本 3 列、大屏 4 列 -->
      <el-col :xs="24" :sm="12" :md="8" :lg="6" v-for="m in shownModules" :key="m.key" class="grid-item">
        <el-card shadow="hover" class="module-card" @click="go(m)">
          <div class="module-name">{{ m.name }}</div>
          <div class="module-desc">
            {{ m.isGroup ? `${m.children.length} 类报表` : `${m.columns.length} 个字段项` }}
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { filterModules } from '@/config/modules'
import { getUser } from '@/api/auth'

const router = useRouter()

// 普通用户不展示仅管理员可见的模块卡片
const shownModules = computed(() => {
  const user = getUser()
  return filterModules(user?.userType === 'ADMIN')
})

function go(m) {
  router.push(m.isGroup ? m.children[0].path : m.path)
}
</script>

<style scoped>
.welcome-card {
  margin-bottom: 16px;
}
.welcome {
  text-align: center;
  padding: 12px 0;
}
.welcome p {
  color: #909399;
  margin-top: 8px;
}
.module-card {
  cursor: pointer;
  text-align: center;
  margin-bottom: 16px;
  transition: transform 0.2s;
}
.module-card:hover {
  transform: translateY(-4px);
}
.module-name {
  font-weight: 600;
  font-size: 15px;
}
.module-desc {
  margin-top: 8px;
  font-size: 12px;
  color: #909399;
}
/* 移动端适配:单列铺满、卡片内边距收紧 */
@media (max-width: 768px) {
  .welcome h2 {
    font-size: 18px;
  }
  .welcome p {
    font-size: 13px;
    line-height: 1.6;
  }
  .welcome-card :deep(.el-card__body) {
    padding: 8px 10px;
  }
  .module-card :deep(.el-card__body) {
    padding: 12px 10px;
  }
  .module-card:hover {
    transform: none;
  }
}
</style>
